import * as api from '../API/baseAPI';
import * as alert from './alerts';
import * as helper from './helper';

export function acceptChanges() {
    api.simplePostRequest('/api/v1/legal/privacy', 'acceptChangesButton', (response) => {
        if (response.error) {
            api.handleErrors(response);
            return;
        }

        helper.hideModal('termsChangesModal');
        alert.showAlert(response.message, 'success');
    });
}

export function showConfirmationModal() {
    helper.showModal('termsChangesModal');
    document.getElementById('termsChangesModalBox').classList.add('hidden');
    document.getElementById('confirmationModalBox').classList.remove('hidden');
}

export function showTermsChangesModal() {
    helper.showModal('termsChangesModal');
    document.getElementById('termsChangesModalBox').classList.remove('hidden');
    document.getElementById('confirmationModalBox').classList.add('hidden');
}

export function deleteAccountFromTerms() {
    if (helper.getService() == 'dönerli') {
        api.simpleDeleteRequest('/api/v1/user/delete', 'deleteAccountChangesButton', helper.logout);
        return;
    }
    api.simpleDeleteRequest('/api/v1/account/delete', 'deleteAccountChangesButton', login);
}

function login(res) {
    if (!res) {
        window.location.href = '/account/logout';
        return;
    }

    if (res.error) {
        showAlert(res.message || res.error, 'error');
        return;
    }
    window.location.href = '/account/login'
}

export function logout() {
    if (helper.getService() == 'dönerli') {
        window.location.href = '/auth/logout';
        return;
    }
    window.location.href = '/account/logout';
}